import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M23.215 3.74a.75.75 0 0 0-.706-.705c-4.852-.282-8.748 1.194-10.423 3.958-1.106 1.827-1.104 4.046-.015 6.163a6.7 6.7 0 0 0-1.328 2.531l-1.525-1.53c.733-1.532.705-3.127-.094-4.453-1.238-2.043-4.094-3.138-7.64-2.93a.75.75 0 0 0-.706.705c-.209 3.547.887 6.404 2.93 7.641.674.412 1.449.63 2.239.63a5.1 5.1 0 0 0 2.208-.531l2.344 2.343v2.688a.75.75 0 0 0 1.5 0v-2.765a5.2 5.2 0 0 1 1.15-3.28 6.9 6.9 0 0 0 3.123.787 5.7 5.7 0 0 0 2.984-.831C22.02 12.489 23.5 8.592 23.215 3.74M4.48 13.838C3.043 12.967 2.23 10.905 2.25 8.25c2.655-.022 4.717.794 5.588 2.232.454.75.528 1.625.23 2.526L5.78 10.719a.75.75 0 0 0-1.06 1.06l2.288 2.29c-.9.297-1.775.223-2.526-.231m13.998-.959c-1.256.76-2.733.819-4.233.188l5.034-5.034a.75.75 0 0 0-1.06-1.06L13.185 12c-.634-1.5-.577-2.977.188-4.233 1.307-2.156 4.406-3.358 8.374-3.265.09 3.967-1.11 7.07-3.268 8.377" />
  </>
);

const Plant = Icon('plant', svgContents);

export default Plant;
